export default __webpack_public_path__ + "static/media/interpreting_carousel_4.cf33e8e7.jpg";